<lib-reactive-form-group
  #form
  [bindTo]="commentReq$ | async"
  (formSubmitted$)="addComment($event)"
  [isLoading]="isLoading"
  [clearOnSubmit]="true">
  <div>
    <div
      class="comment-container"
      [style.height]="sanitizer.bypassSecurityTrustStyle('calc(100vh - 25rem - ' + headerHeight + ')')"
      [style.justify-content]="(totalNumberOfComments$ | async) === 0 || isLoading ? 'flex-end' : 'normal'">
      <div [hidden]="!(totalNumberOfComments$ | async) || isLoading">
        <app-comment-list class="mt-auto" [comments]="readComments$ | async" [visibilityLabel]="visibilityLabel" />
        <div [hidden]="!(unreadComments$ | async)?.length" class="unread-separator" i18n>Unread</div>
        <div class="no" #unreadCommentsScroll></div>
        <app-comment-list
          [hidden]="!(unreadComments$ | async)?.length"
          [comments]="unreadComments$ | async"
          [visibilityLabel]="visibilityLabel" />
      </div>
      <ng-container *ngIf="(totalNumberOfComments$ | async) === 0 && !isLoading">
        <span class="no-comments" i18n>No comments yet.</span>
      </ng-container>
      <ng-container *ngIf="isLoading">
        <div class="d-flex flex-column gap-4 mb-3">
          <lib-loading-shimmer
            *ngFor="let c of unreadComments$ | async"
            [borderRadius]="'1rem'"
            [height]="'1.5rem'"
            [width]="'3rem'" />
          <lib-loading-shimmer [borderRadius]="'1rem'" [height]="'1.5rem'" [width]="'3rem'" />
        </div>
      </ng-container>
    </div>
    <div class="input-container">
      <div
        class="tag-input"
        [class.over-max-length]="commentExceedsMaxLength$ | async"
        [style.padding-bottom]="isLoading ? '1.5rem' : '0.5rem'">
        <lib-reactive-form-tagging-input
          #tag
          (valueChanged)="onCommentValueChange($event)"
          [inputName]="'comment'"
          [required]="true"
          [bindingProperty]="'comment'"
          label="Comment"
          (dropdownSearchText)="filterDropdown($event)"
          [users]="dropdownItems"
          [customResultTemplate]="customTemplate"
          [showCharacterCount]="false"
          [maxLength]="maxCommentLength"
          placeholder="Add a Comment..."
          i18n-label
          i18n-placeholder />
        <div class="comment-meta">
          <span *ngIf="commentExceedsMaxLength$ | async" class="character-limit-error" role="alert" i18n>
            Comment character count must be equal to or lower than limit in order to submit
          </span>
          <span class="character-count">{{ commentLength$ | async | number }} / {{ maxCommentLength | number }}</span>
        </div>
      </div>
    </div>
  </div>
</lib-reactive-form-group>

<ng-template #customTemplate let-user>
  <div class="dropdown-item" [attr.data-user-id]="user.id">
    <app-user-profile-badge [initials]="user.initials" [profileBadgeConfiguration]="user.profileBadgeConfiguration" />
    {{ user.value }}
  </div>
</ng-template>
